import { Avatar, Flex, Text } from '@mantine/core';
import { User } from '@propelauth/react';

import classes from './AvatarWithName.module.css';

const AvatarWithName = ({ user, includeName }: { user: User; includeName?: boolean }) => {
  const firstName = user.firstName ?? '';
  const lastName = user.lastName ?? '';
  const email = user.email ?? '';
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}` || email.charAt(0).toUpperCase();
  const displayName = firstName ? `${firstName} ${lastName.charAt(0)}`.trim() : email;

  return (
    <Flex gap={'sm'} align={'center'} classNames={{ root: classes.root }}>
      {/* <Avatar src={user.pictureUrl} alt={user.firstName} size={'32px'}>
        {!user.pictureUrl &&
          user.firstName &&
          user.lastName &&
          user.firstName[0] + user.lastName[0]}
      </Avatar>
      */}
      <Avatar
        src={null}
        alt={displayName}
        size={'32px'}
        color="#f8e8ef"
        style={{ border: '1px solid #EA569D' }}
        classNames={{ placeholder: classes.placeholder }}
      >
        {initials}
      </Avatar>
      {includeName && (
        <Text size="sm" c={'black'}>
          {displayName}
        </Text>
      )}
    </Flex>
  );
};

export default AvatarWithName;
